import { ReactElement } from "react";
import { Box } from "@twilio-paste/core/box";
import { styled } from "@twilio-paste/core/styling-library";

import { ArtificialIntelligenceIcon } from "@twilio-paste/icons/esm/ArtificialIntelligenceIcon";
import { types, copy } from "./definitions";

const LoaderContainer = styled(Box)<{ loading: boolean }>`
  display: none;
  background-color: white;
  bottom: 0;
  opacity: 0;
  position: relative;
  transition: opacity 0.2s cubic-bezier(0.075, 0.82, 0.165, 1),
    transform 0.3s cubic-bezier(0.075, 0.82, 0.165, 1);
  width: 100%;

  ${({ loading }): string | boolean =>
    loading &&
    `
  display: flex;
  align-content: center;
  opacity: 1;
  `}
`;

const IsTypingLoader = ({
  loading,
}: types.IsTypingLoaderProps): ReactElement => {
  return (
    <LoaderContainer
      fontWeight={"fontWeightMedium"}
      paddingY="space40"
      color={"colorTextWeak"}
      loading={loading}
    >
      <Box color="colorTextIcon" marginRight="space30">
        <ArtificialIntelligenceIcon decorative />
      </Box>
      <Box as="span">{copy.IS_LOADING_TEXT}</Box>
      <EllipsesAnimation />
    </LoaderContainer>
  );
};

const EllipsesContainer = styled(Box)`
  span {
    opacity: 0;
    -webkit-animation: ellipsis-dot 6s infinite;
    animation: ellipsis-dot 3s infinite;
  }

  span:nth-child(1) {
    -webkit-animation-delay: 0s;
    animation-delay: 0s;
  }

  span:nth-child(2) {
    -webkit-animation-delay: 0.2s;
    animation-delay: 0.2s;
  }

  span:nth-child(3) {
    -webkit-animation-delay: 0.4s;
    animation-delay: 0.4s;
  }

  @keyframes ellipsis-dot {
    0% {
      opacity: 0;
    }
    50% {
      opacity: 1;
    }
    100% {
      opacity: 0;
    }
  }

  @keyframes ellipsis-dot {
    0% {
      opacity: 0;
    }
    50% {
      opacity: 1;
    }
    100% {
      opacity: 0;
    }
  }
`;

const EllipsesAnimation = (): ReactElement => {
  return (
    <EllipsesContainer>
      <Box as="span">.</Box>
      <Box as="span">.</Box>
      <Box as="span">.</Box>
    </EllipsesContainer>
  );
};

export default IsTypingLoader;
